import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";
import { assertMutableRecordId, assertNoDemoReportMutations } from "./demoReportMutationGuard";

export interface RenameRecordInputDto {
  recordId: string;
  newName: string;
}

/**
 * Use case: переименование записи.
 */
export class RenameRecordUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(input: RenameRecordInputDto): Promise<void> {
    const { recordId, newName } = input;
    if (!recordId.trim()) {
      throw new Error("recordId is required");
    }
    if (!newName.trim()) {
      throw new Error("newName is required");
    }
    assertMutableRecordId(recordId);

    const request = {
      change_names: [{ id: recordId, name: newName }],
      for_archive: [],
      for_delete: [],
      delete_link: [],
    };
    assertNoDemoReportMutations(request);
    await this.gateway.updateRecords(request);
  }
}
